<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5854_9644)">
        <rect x="3" y="3" width="4" height="4" fill="var(--icon-color)" />
        <rect x="3" y="9" width="4" height="4" fill="var(--icon-color)" />
        <rect x="9" y="3" width="4" height="4" fill="var(--icon-color)" />
        <rect x="9" y="9" width="4" height="4" fill="var(--icon-color)" />
    </g>
    <defs>
        <clipPath id="clip0_5854_9644">
            <rect width="16" height="16" fill="var(--bg-color)" />
        </clipPath>
    </defs>
</svg>
